/**
 * Vacation-request day row state.
 * Methods stay on the prototype so Vue 2 can observe data fields without
 * wrapping setEntryTime/setExitTime into reactive properties.
 */
class VacationResponseDay {
  constructor(interval) {
    this.date = interval.date;
    this.year = interval.year;
    this.week = interval.week;
    this.isComing = interval.isComing;
    this.entryTime = interval.entryTime || '';
    this.exitTime = interval.exitTime || '';
    this.useTimes = interval.useTimes;
    this.isDisabled = interval.isDisabled;
    this.interval = interval;
  }

  syncToInterval() {
    this.interval.setIsComing(this.isComing);
    this.interval.setEntryTime(this.entryTime);
    this.interval.setExitTime(this.exitTime);
  }

  setIsComing(value) {
    this.isComing = value;
    this.interval.setIsComing(value);
  }

  setEntryTime(entryTime) {
    this.entryTime = entryTime;
    this.interval.setEntryTime(entryTime);
  }

  setExitTime(exitTime) {
    this.exitTime = exitTime;
    this.interval.setExitTime(exitTime);
  }

  setSubmitClicked(submitClicked) {
    this.interval.setSubmitClicked(submitClicked);
  }

  isValid() {
    this.syncToInterval();
    return this.interval.isValid();
  }

  get validator() {
    return this.interval.validator;
  }

  get specificOpeningHour() {
    return this.interval.specificOpeningHour;
  }

  getIsClosingDay() {
    return this.interval.getIsClosingDay();
  }

  getIsSpecificOpeningHours() {
    return this.interval.getIsSpecificOpeningHours();
  }

  getStartTime() {
    return this.interval.getStartTime();
  }

  getEndTime() {
    return this.interval.getEndTime();
  }

  getShowHasTimesError() {
    return this.interval.getShowHasTimesError();
  }

  getShowIsWithinOpeningHourError() {
    return this.interval.getShowIsWithinOpeningHourError();
  }

  getShowIsValidTimesError() {
    return this.interval.getShowIsValidTimesError();
  }
}

export function wrapVacationInterval(interval) {
  return new VacationResponseDay(interval);
}

export function setVacationDayIsComing(day, isComing) {
  day.setIsComing(isComing);
}

export function setVacationDaysIsComing(days, isComing) {
  days.forEach(day => {
    if (!day.isDisabled) {
      day.setIsComing(isComing);
    }
  });
}
